export default __webpack_public_path__ + "static/media/paper-off.0a31e869.png";